import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoReintento } from '../_models/flujo-venta-paso-reintento';
import { FlujoVentaPasoReintentoCausalSolicitud } from '../_models/flujo-venta-paso-reintento-causal-solicitud';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoReintentoCausalSolicitudService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVPReintentosCausalesSolicitudes';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud ) );
  }

  listadoPorFlujoVenta( idFlujoVenta: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVentaPaso/' + idFlujoVenta ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud[] ) );
  }

  listadoHabilitadoPorIdFVPasoReintento( idFlujoVentaPasoReintento: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVentaPasoReintento/' + idFlujoVentaPasoReintento + '/enabled' ).pipe( map( res => res as any[] ) );
  }

  listadoHabilitadosPorFlujoVentaYModoAutenticacion( idFlujoVenta: string, idModoAuth: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVentaPaso/' + idFlujoVenta + '/modoAutenticacion/' + idModoAuth + '/enabled').pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud[] ) );
  }

  crear( regCrear: FlujoVentaPasoReintentoCausalSolicitud ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoReintento ) );
  }

  actualizar( regActualizar: FlujoVentaPasoReintentoCausalSolicitud ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud ) );
  }

  bulk( regActualizar: FlujoVentaPasoReintentoCausalSolicitud[] ) {
    regActualizar.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as FlujoVentaPasoReintentoCausalSolicitud[] ) );
  }
}
